'use client';

import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { createContext } from '~logic/lib/react';
import { jsx as _jsx } from "react/jsx-runtime";

var _createContext = createContext("Config"),
    _createContext2 = _slicedToArray(_createContext, 2),
    Provider = _createContext2[0],
    useConfigCtx = _createContext2[1];

/**
 * provider of the current app run config
 * combines both common env config & specific speedlo-next config (stage, BE endpoint URL, Sentry link, ...)
 * use the `useConfig` hook to access the config
 */
export var ConfigProvider = function ConfigProvider(_ref) {
  var children = _ref.children,
      config = _ref.config;
  return /*#__PURE__*/_jsx(Provider, {
    value: config,
    children: children
  });
};
export { useConfigCtx };